














































































import { Component, Mixins, Watch } from "vue-property-decorator";
import CompanyMixin, { GET_COMPANIES } from "@/mixins/http/CompanyMixin";
import Company, { CompanyFilter, Typologies } from "@/models/Company";
import VSelect from "@/components/VSelect.vue";
import VDataTable from "@monade/vue-components/src/components/VDataTable.vue";
import Paginator from "@monade/vue-components/src/components/VPaginator.vue";
import VSignPost from "@/components/Company/VSignPost.vue";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";
import VMiniLogo from "@/components/VMiniLogo.vue";

interface ColumnData {
  name: string;
  label: string;
}

@Component({ components: { VSelect, VDataTable, Paginator, VMiniLogo } })
export default class List extends Mixins(CompanyMixin) {
  filter = new CompanyFilter();
  companies: Company[] = [];
  typologies = [{ id: "tutte", text: "Tutte le tipologie" }, ...Typologies];
  currentTypology = "tutte";
  loading = false;
  currentTerm = "";
  timeout = 0;

  @RegisterHttp(GET_COMPANIES)
  private companiesRequest?: RequestData;

  mounted() {
    this.filter.page = 0;
    this.loadData();
  }

  get columns() {
    const columns: ColumnData[] = [];
    this.pushColumnInAllScreens(columns, {
      name: "fullname",
      label: "Cliente",
    });
    this.pushColumnInAllScreens(columns, {
      name: "businessSector.name",
      label: "Settore",
    });
    this.pushColumnInAllScreens(columns, {
      name: "typology",
      label: "Tipologia",
    });
    this.pushColumnInAllScreens(columns, { name: "controls", label: "" });

    return columns;
  }

  get meta() {
    return this.companiesRequest?.meta;
  }

  get totalRows() {
    return this.companiesRequest?.meta?.totalRows || 0;
  }

  logoPath(value: Company) {
    return VSignPost.removeHeadingBackSlash(value.croppedLogo || "");
  }

  goToDetails(value: Company) {
    this.$router.push({ name: "company_details", params: { id: value.id } });
  }

  @Watch("currentTypology")
  onTipologyChanged(newValue: string) {
    if (newValue === "tutte") {
      delete this.filter.typology;
    } else {
      this.filter.typology = newValue;
    }
    this.loadData();
  }

  @Watch("currentTerm")
  onTermChanged(newValue: string) {
    if (newValue.length > 2) {
      this.filter.name = newValue;
    } else {
      delete this.filter.name;
    }
    this.loadData();
  }

  private pushColumnInAllScreens(columns: ColumnData[], column: ColumnData) {
    columns.push(column);
  }

  getTypology(typology: string) {
    return this.typologies.find((e) => e.id === typology)?.text;
  }

  loadData() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(async () => {
      this.loading = true;
      this.companies = await this.getCompanies(this.filter);
      this.loading = false;
    }, 300);
  }

  onPageChange(page: number) {
    this.filter.page = page;
    this.loadData();
  }
}
